import React from 'react';
import TRDialog from './TRDialog';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UnpairedDialog(props) {
  const {
    show,
    onClose
  } = props;
  return /*#__PURE__*/_jsx(TRDialog, {
    type: "message",
    show: show,
    onClose: onClose,
    onOkay: onClose,
    okayVariant: "primary",
    title: "Locator is Unpaired",
    message: "If locator battery is still operational, you can repair it to this vehicle or to another. It not, the locator status will remain as stolen."
  });
}